import { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

import { TemplateFields, templateGQLFields } from './template.fields.js'

/**
 * Callers should pass an explicit `requiredPlans` so the frontend — not the
 * backend auto-filter — owns template visibility. See
 * `@bettermode/domain/templates/plan-tier` for the capability → tier mapping.
 */
export function getTemplatesGQLQuery(fields: TemplateFields): DocumentNode {
  return gql`
    query templates(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $reverse: Boolean
      $entityTypes: [TemplateEntityType!]
      $requiredPlans: [TemplatePlanTier!]
      $status: StoreItemStatus
    ) {
      templates(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        reverse: $reverse
        entityTypes: $entityTypes
        requiredPlans: $requiredPlans
        status: $status
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${templateGQLFields(fields)}
          }
        }
        nodes {
          ${templateGQLFields(fields)}
        }
      }
    }
  `
}
